import * as React from "react";
import {
  formatMoney,
  redirectFileLocalUrl,
} from "shared/plugins/string-helper";
import { useAppDispatch } from "app.hook";
import "./item-view-cart-mobile.less";
import { ShoppingCartItem } from "states/shopping-cart/shopping-cart.models";
import {
  calculateTotal,
  removeItemShoppingCart,
  updateQuantityItemShoppingCart,
} from "states/shopping-cart/shopping-cart.slice";
import {
  closeConfirmModal,
  showConfirmModal,
} from "states/global-value/global-value.slice";
import { ConfirmModel } from "states/global-value/global-value.models";
import { IconMinus, IconPlus } from "themes";
export interface IButtonModalViewCartProps {
  item: ShoppingCartItem;
  index: number;
}

export function ItemModalViewMobileCart({
  item,
  index,
}: IButtonModalViewCartProps) {
  const dispatch = useAppDispatch();
  const handleRemove = () => {
    dispatch(removeItemShoppingCart(index));
    dispatch(closeConfirmModal());
  };

  const handleUpdateQuantity = (quantity: number) => {
    dispatch(updateQuantityItemShoppingCart({ index, quantity }));
  };

  return (
    <div className="item-cart-mobile">
      <button
        className="remove-item-btn"
        onClick={() => {
          dispatch(
            showConfirmModal({
              title: "Warning",
              message: "Are you sure you want to remove this item?",
              onYes: () => {
                handleRemove();
              },
            } as ConfirmModel)
          );
        }}
      >
        ✕
      </button>
      <div className="img-container img--container-center">
        {item.image !== null ? (
          <img
            className="object-center"
            src={redirectFileLocalUrl(item.image)}
            alt=""
          />
        ) : (
          <div className="flex content-center items-center avatar-thumb h-full w-full bg-yellow-50"></div>
        )}
      </div>
      <div className="info">
        <div className="name">
          <span>{item.name}</span>
          <div className="item-modifiers">
            {item.modifiers.map((modi, idx) => (
              <span className="modifier-tag" key={idx}>{modi.name} ({formatMoney(modi.price * modi.quantity, 2, ".", ",", "$")}) Qty: {modi.quantity}</span>
            ))}
          </div>
        </div>
        <div className="flex justify-between content-center items-center">
          <div className="text-red">
            {formatMoney(calculateTotal(item), 2, ".", ",", "$")}
          </div>
          <div className="quantity-container">
            <button
              onClick={() => {
                if (item.quantity - 1 === 0) {
                  dispatch(
                    showConfirmModal({
                      title: "Warning",
                      message: "Are you sure you want to delete this?",
                      onYes: () => {
                        handleRemove();
                      },
                    } as ConfirmModel)
                  );
                  return -1;
                }

                handleUpdateQuantity(item.quantity - 1);
              }}
              className="btn--default"
            >
              <IconMinus width={16} />
            </button>
            <span>{item.quantity}</span>
            <button
              onClick={() => {
                handleUpdateQuantity(item.quantity + 1);
              }}
              className="btn--default"
            >
              <IconPlus width={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
